import { formatPrice } from "../../helpers/format";

import getSymbolFromCurrency from "currency-symbol-map";
import {
  GET_GLOBAL_TICKER,
  GET_GLOBAL_TICKER_ERROR,
  SORT_GLOBAL_TICKER_BY_PRICE,
  SORT_GLOBAL_TICKER_BY_24H,
  SORT_GLOBAL_TICKER_BY_7D,
  SORT_GLOBAL_TICKER_BY_NAME,
  SORT_GLOBAL_TICKER_BY_RANK,
  SORT_GLOBAL_TICKER_BY_MARKET_CAP,
  SORT_GLOBAL_TICKER_BY_VOLUME_IN_24H,
  SEARCH_COINS,
  GET_SINGLE_CRYPTO_DETAILS,
  GET_SINGLE_CRYPTO_DETAILS_ERROR,
  CLEAR_SINGLE_CRYPTO_DETAILS,
  START_LOADING,
  STOP_LOADING,
  GET_ALL_CRYPTO_COINS,
  GET_COMPARE_CRYPTO_COIN_DATA1,
  GET_COMPARE_CRYPTO_COIN_DATA2,
  SET_COMPARE_CRYPTO_COIN_DATA1,
  SET_COMPARE_CRYPTO_COIN_DATA2,
  SET_CONVT,
  GET_FAVOURITE_CRYPTO_COINS,
  GET_NAMES_OF_DISPLAYED_CRYPTO_COINS,
  GET_CRYPTO_COINS_SPARKLINES,
  SET_CRYPTOSTR,
  CLEAR_SPARKLINES,
  GET_SINGLE_CRYPTO_COINS_SPARKLINES,
  GET_COMPARE_CRYPTO_COIN_DATA1_SPARKLINE,
  GET_COMPARE_CRYPTO_COIN_DATA2_SPARKLINE,
  SET_LIVE_PRICE,
  GET_EXCHANGE_RATE,
  GET_FAVOURITE_CRYPTO_COINS_SPARKLINES,
  SET_RANDOM_DATA,
  SORT_NORMALLY,
} from "../types";

function isEligible(value) {
  if (value !== false || value !== null || value !== "") {
    return value;
  }
}
const parameterReducer = (state, action) => {
  let coinData;
  switch (action.type) {
    case START_LOADING:
      return { ...state, loading: true };
    case STOP_LOADING:
      return { ...state, loading: false };
    case GET_COMPARE_CRYPTO_COIN_DATA1:
      return { ...state, compareCryptoCoinData1: action.payload };
    case GET_COMPARE_CRYPTO_COIN_DATA2:
      return { ...state, compareCryptoCoinData2: action.payload };
    case SET_COMPARE_CRYPTO_COIN_DATA1:
      return { ...state, cryptoCoinData1: action.payload };
    case SET_COMPARE_CRYPTO_COIN_DATA2:
      return { ...state, cryptoCoinData2: action.payload };
    case SET_CONVT:
      return {
        ...state,
        convt: action.payload,
        currencySymbol: getSymbolFromCurrency(action.payload),
      };
    case GET_FAVOURITE_CRYPTO_COINS:
      return { ...state, favouriteCryptoCoins: action.payload };
    case GET_NAMES_OF_DISPLAYED_CRYPTO_COINS:
      let cryptoArr =
        action.payload === 1
          ? state.cryptoData && state.cryptoData.length > 0
            ? state.cryptoData.map((d) => d.id)
            : []
          : state.singleCryptoData
          ? [state.singleCryptoData[0]?.name]
          : [];
      let cryptoStr = cryptoArr?.length > 0 ? cryptoArr.join(",") : null;
      return {
        ...state,
        cryptoStr,
      };
    case GET_COMPARE_CRYPTO_COIN_DATA1_SPARKLINE:
      return { ...state, compareCryptoCoinData1Sparkline: action.payload };
    case GET_COMPARE_CRYPTO_COIN_DATA2_SPARKLINE:
      return { ...state, compareCryptoCoinData2Sparkline: action.payload };
    case GET_CRYPTO_COINS_SPARKLINES:
      return { ...state, sparklineData: action.payload };
    case GET_FAVOURITE_CRYPTO_COINS_SPARKLINES:
      return { ...state, favouriteSparklineData: action.payload };
    case GET_SINGLE_CRYPTO_COINS_SPARKLINES:
      return { ...state, singleSparklineData: action.payload };
    case CLEAR_SPARKLINES:
      return { ...state, sparklineData: null };
    case GET_ALL_CRYPTO_COINS:
      return {
        ...state,
        allCoinsData: action.payload,
      };
    case SET_RANDOM_DATA:
      return {
        ...state,
        cryptoData: [...Array(20).keys()].map((c, index) => {
          return { rank: index + 1 };
        }),
      };
    case GET_GLOBAL_TICKER:
      // console.log( action.payload.map((d, index)=>{return ({...d,price:state.exchangeRate?Number(d.price)*state.exchangeRate:Number(d.price)})}) +" here in reducer");
      let headerCoins = action.payload.filter((d, index) => index < 5);
      return {
        ...state,
        cryptoData: action.payload,
        headerCoins: headerCoins,
      };
    case SET_LIVE_PRICE:
      let liveData = {};

      for (const key in action.payload) {
        liveData = {
          ...liveData,
          [key]: action.payload[key] / state.exchangeRate,
        };
      }
      return {
        ...state,
        livePriceData: liveData,
      };

    case GET_GLOBAL_TICKER_ERROR:
      return { ...state, cryptoDataError: action.payload };
    case SORT_GLOBAL_TICKER_BY_PRICE:
      action.payload === 1
        ? (coinData = state.filter
            ? state.filteredCryptoData
            : state.cryptoData)
        : (coinData = state.favouriteCryptoCoins);

      state.order === 2
        ? coinData.sort((a, b) => (Number(a.price) > Number(b.price) ? -1 : 1))
        : state.order === 1
        ? coinData.sort((a, b) => (Number(a.price) > Number(b.price) ? -1 : 1))
        : coinData.sort((a, b) => (Number(a.price) > Number(b.price) ? 1 : -1));
      return {
        ...state,
        order: state.order === 2 ? 0 : state.order === 1 ? 0 : 1,
        favouriteCryptoCoins:
          action.payload === 2 ? coinData : state.favouriteCryptoCoins,
        cryptoData:
          action.payload === 1 && !state.filter ? coinData : state.cryptoData,
        filteredCryptoData:
          action.payload === 1 && state.filter
            ? coinData
            : state.filteredCryptoData,
      };
    case SORT_GLOBAL_TICKER_BY_24H:
      action.payload === 1
        ? (coinData = state.filter
            ? state.filteredCryptoData
            : state.cryptoData)
        : (coinData = state.favouriteCryptoCoins);
      coinData = coinData.filter((c) => isEligible(c["1d"]?.price_change_pct));

      state.order === 2
        ? coinData.sort((a, b) =>
            Number(a["1d"].price_change_pct) > Number(b["1d"].price_change_pct)
              ? -1
              : 1
          )
        : state.order === 1
        ? coinData.sort((a, b) =>
            Number(a["1d"].price_change_pct) > Number(b["1d"].price_change_pct)
              ? -1
              : 1
          )
        : coinData.sort((a, b) =>
            Number(a["1d"].price_change_pct) > Number(b["1d"].price_change_pct)
              ? 1
              : -1
          );

      return {
        ...state,
        order: state.order === 2 ? 0 : state.order === 1 ? 0 : 1,
        favouriteCryptoCoins:
          action.payload === 2 ? coinData : state.favouriteCryptoCoins,
        cryptoData:
          action.payload === 1 && !state.filter ? coinData : state.cryptoData,
        filteredCryptoData:
          action.payload === 1 && state.filter
            ? coinData
            : state.filteredCryptoData,
      };
    case SORT_GLOBAL_TICKER_BY_7D:
      action.payload === 1
        ? (coinData = state.filter
            ? state.filteredCryptoData
            : state.cryptoData)
        : (coinData = state.favouriteCryptoCoins);
      coinData = coinData.filter((c) => isEligible(c["7d"]?.price_change_pct));
      state.order === 2
        ? coinData.sort((a, b) =>
            Number(a["7d"].price_change_pct) > Number(b["7d"].price_change_pct)
              ? -1
              : 1
          )
        : state.order === 1
        ? coinData.sort((a, b) =>
            Number(a["7d"].price_change_pct) > Number(b["7d"].price_change_pct)
              ? -1
              : 1
          )
        : coinData.sort((a, b) =>
            Number(a["7d"].price_change_pct) > Number(b["7d"].price_change_pct)
              ? 1
              : -1
          );

      return {
        ...state,
        order: state.order === 2 ? 0 : state.order === 1 ? 0 : 1,
        favouriteCryptoCoins:
          action.payload === 2 ? coinData : state.favouriteCryptoCoins,
        cryptoData:
          action.payload === 1 && !state.filter ? coinData : state.cryptoData,
        filteredCryptoData:
          action.payload === 1 && state.filter
            ? coinData
            : state.filteredCryptoData,
      };
    case SORT_GLOBAL_TICKER_BY_RANK:
      action.payload === 1
        ? (coinData = state.filter
            ? state.filteredCryptoData
            : state.cryptoData)
        : (coinData = state.favouriteCryptoCoins);
      state.order === 2
        ? coinData.sort((a, b) => (Number(a.rank) > Number(b.rank) ? -1 : 1))
        : state.order === 1
        ? coinData.sort((a, b) => (Number(a.rank) > Number(b.rank) ? -1 : 1))
        : coinData.sort((a, b) => (Number(a.rank) > Number(b.rank) ? 1 : -1));

      return {
        ...state,
        order: state.order === 2 ? 0 : state.order === 1 ? 0 : 1,
        favouriteCryptoCoins:
          action.payload === 2 ? coinData : state.favouriteCryptoCoins,
        cryptoData:
          action.payload === 1 && !state.filter ? coinData : state.cryptoData,
        filteredCryptoData:
          action.payload === 1 && state.filter
            ? coinData
            : state.filteredCryptoData,
      };

    case SORT_NORMALLY:
      coinData =
        state.cryptoData &&
        state.cryptoData.length > 0 &&
        state.cryptoData.filter((c) => isEligible(c.rank));
      return {
        ...state,
        cryptoData:
          coinData &&
          coinData.length > 0 &&
          coinData.sort((a, b) => (Number(a.rank) > Number(b.rank) ? 1 : -1)),
      };
    case SORT_GLOBAL_TICKER_BY_NAME:
      action.payload === 1
        ? (coinData = state.filter
            ? state.filteredCryptoData
            : state.cryptoData)
        : (coinData = state.favouriteCryptoCoins);
      state.order === 2
        ? coinData.sort((a, b) => (a.name > b.name ? -1 : 1))
        : state.order === 1
        ? coinData.sort((a, b) => (a.name > b.name ? -1 : 1))
        : coinData.sort((a, b) => (a.name > b.name ? 1 : -1));

      return {
        ...state,
        order: state.order === 2 ? 0 : state.order === 1 ? 0 : 1,
        favouriteCryptoCoins:
          action.payload === 2 ? coinData : state.favouriteCryptoCoins,
        cryptoData:
          action.payload === 1 && !state.filter ? coinData : state.cryptoData,
        filteredCryptoData:
          action.payload === 1 && state.filter
            ? coinData
            : state.filteredCryptoData,
      };
    case SORT_GLOBAL_TICKER_BY_MARKET_CAP:
      action.payload === 1
        ? (coinData = state.filter
            ? state.filteredCryptoData
            : state.cryptoData)
        : (coinData = state.favouriteCryptoCoins);
      coinData = coinData.filter((c) => isEligible(c.market_cap));
      state.order === 2
        ? coinData.sort((a, b) =>
            Number(a.market_cap) > Number(b.market_cap) ? -1 : 1
          )
        : state.order === 1
        ? coinData.sort((a, b) =>
            Number(a.market_cap) > Number(b.market_cap) ? -1 : 1
          )
        : coinData.sort((a, b) =>
            Number(a.market_cap) > Number(b.market_cap) ? 1 : -1
          );

      return {
        ...state,
        order: state.order === 2 ? 0 : state.order === 1 ? 0 : 1,
        favouriteCryptoCoins:
          action.payload === 2 ? coinData : state.favouriteCryptoCoins,
        cryptoData:
          action.payload === 1 && !state.filter ? coinData : state.cryptoData,
        filteredCryptoData:
          action.payload === 1 && state.filter
            ? coinData
            : state.filteredCryptoData,
      };
    case SORT_GLOBAL_TICKER_BY_VOLUME_IN_24H:
      action.payload === 1
        ? (coinData = state.filter
            ? state.filteredCryptoData
            : state.cryptoData)
        : (coinData = state.favouriteCryptoCoins);
      coinData = coinData.filter((c) => isEligible(c["1d"]?.volume));
      state.order === 2
        ? coinData.sort((a, b) =>
            Number(a["1d"].volume) > Number(b["1d"].volume) ? -1 : 1
          )
        : state.order === 1
        ? coinData.sort((a, b) =>
            Number(a["1d"].volume) > Number(b["1d"].volume) ? -1 : 1
          )
        : coinData.sort((a, b) =>
            Number(a["1d"].volume) > Number(b["1d"].volume) ? 1 : -1
          );

      return {
        ...state,
        order: state.order === 2 ? 0 : state.order === 1 ? 0 : 1,
        favouriteCryptoCoins:
          action.payload === 2 ? coinData : state.favouriteCryptoCoins,
        cryptoData:
          action.payload === 1 && !state.filter ? coinData : state.cryptoData,
        filteredCryptoData:
          action.payload === 1 && state.filter
            ? coinData
            : state.filteredCryptoData,
      };
    // case SEARCH_COINS:
    //   console.log(action.payload);
    //   let filteredData =
    //     action.payload !== ""
    //       ? state.cryptoData.filter((n) =>
    //           n.name.toLowerCase().includes(action.payload.toLowerCase())
    //         )
    //       : null;

    //   return {
    //     ...state,
    //     filteredCryptoData: filteredData,
    //     filter: action.payload === "" ? false : true,
    //   };

    case SEARCH_COINS:
      let filteredSearchData =
        action.payload !== ""
          ? state.cryptoData?.filter(
              (n) =>
                n.name.toLowerCase().includes(action.payload.toLowerCase()) ||
                n.id.toLowerCase().includes(action.payload.toLowerCase())
            )
          : null;
      return {
        ...state,
        filteredCryptoData: filteredSearchData,
      };
    // filter: action.payload === "" ? false : true,
    case GET_SINGLE_CRYPTO_DETAILS:
      return {
        ...state,
        filteredCryptoData: null,
        singleCryptoData:
          action.payload && action.payload.length > 0 ? action.payload : null,
        // singleCryptoPrice:
        //   action.payload &&
        //   action.payload.length > 0 ?
        //   Number(action.payload[0].price):null,
      };
    case GET_SINGLE_CRYPTO_DETAILS_ERROR:
      return { ...state, cryptoDataError: action.payload };
    case CLEAR_SINGLE_CRYPTO_DETAILS:
      return {
        ...state,
        singleCryptoData: null,
      };
    case SET_CRYPTOSTR:
      return { ...state, cryptoStr: action.payload };
    case GET_EXCHANGE_RATE:
      let rate = Number(action.payload);
      localStorage.setItem(
        "currencyDetails",
        JSON.stringify({
          convt: state.convt,
          exchangeRate: rate,
          currencySymbol: state.currencySymbol,
        })
      );

      let liveData1 = {};
      if (state.livePriceData) {
        for (const key in state.livePriceData) {
          liveData1 = {
            ...liveData1,
            [key]: formatPrice(
              (state.livePriceData[key] / rate) * state.exchangeRate
            ),
          };
        }
      }

      return {
        ...state,
        exchangeRate: rate,
        livePriceData: state.livePriceData && liveData1,
      };
    default:
      return { ...state };
  }
};

export default parameterReducer;
